let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gMZ9X")).then(() => parcelRequire('6re9h'));